// extracted by css-extract-rspack-plugin
export default {"aiMarkdown":"xJSRw","tableWrapper":"FEW11","tableContainer":"LU383","codeBlock":"jQG9Z","copyCodeButton":"bNjkr","smartLink":"yk1Fp","smartLinkInner":"jQ011","icon":"LoRM7"};